module.exports = "/images/Malaysia.png?d76edaac36e73407bc6808f3316aa176";